module.exports = __webpack_public_path__ + "static/media/no_worksheet_image.ae1f81fb.png";